import associateEditors from "./associateEditors";

export default [...associateEditors];
